import React, {useEffect} from 'react';

const SuccessfulOrder = ({onClose}) => {
    useEffect(() => {

        const timer = setTimeout(() => {
            onClose();
        }, 4000);


        return () => clearTimeout(timer);
    }, [onClose]);



    return (
        <div className ='success-notification'>
            <h2>Дякуємо! Ваша заявка успішно надіслана.</h2>
            <p>Наш менеджер зв'яжеться з вами найближчим часом, щоб уточнити всі деталі. Очікуйте на дзвінок!</p>
        </div>
    );
};

export default SuccessfulOrder;